const messageContact = (number: string): any => alert("messaged " + number)

export default messageContact
